import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import {
  NzMenuDirective,
  NzMenuItemComponent,
  NzSubMenuComponent,
} from 'ng-zorro-antd/menu';
import { RouterLink } from '@angular/router';
import { NzIconDirective } from 'ng-zorro-antd/icon';

@Component({
  host: { ngSkipHydration: 'true' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-menu',
  imports: [
    NzColDirective,
    NzMenuDirective,
    NzMenuItemComponent,
    NzRowDirective,
    NzSubMenuComponent,
    NzIconDirective,
    RouterLink,
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.less',
})
export class MenuComponent {}
